'use client';

import { useEffect } from 'react';

export function VConsole() {
  useEffect(() => {
    void import('@/app/utils/vconsole').then(({ initVConsole }) => {
      initVConsole();
    });
  }, []);

  return null;
}
